export const FAQ_CLUSTERS = [
  {
    id: 'overview',
    title: 'Overview',
    items: [
      {
        question: 'What is Neevii?',
        answer:
          'Neevii is accounting software for UK small businesses, including freelancers, sole traders, and limited company directors. It focuses on simplifying bookkeeping, invoicing, and tax preparation using AI-assisted workflows.',
      },
      {
        question: 'Who is Neevii for?',
        answer:
          'Neevii is built for small businesses, side incomes, and early-stage companies that want simple, guided accounting without unnecessary enterprise-level complexity.',
      },
      {
        question: 'Is Neevii only for the UK?',
        answer: 'Neevii is currently focused on UK accounting and HMRC-related workflows.',
      },
      {
        question: 'Is Neevii a replacement for an accountant?',
        answer:
          'Neevii is designed to simplify day-to-day accounting and tax preparation. Some businesses may still choose to work with an accountant depending on their needs.',
      },
      {
        question: 'Can Neevii connect to my bank?',
        answer:
          'Neevii supports importing transactions via CSV. Open Banking connections are planned and may be available depending on rollout stage.',
      },
    ],
  },
  {
    id: 'sa100',
    title: 'Self Assessment (SA100)',
    items: [
      {
        question: 'Can Neevii help with Self Assessment?',
        answer:
          'Yes. Neevii helps prepare Self Assessment by organising income and expenses and guiding users through HMRC-ready workflows.',
      },
      {
        question: 'What is SA100?',
        answer:
          'SA100 is the main Self Assessment tax return form used for UK individuals. It covers income and tax details for a tax year.',
      },
      {
        question: 'Do I need to file Self Assessment if I earn under \u00A31,000?',
        answer:
          'In most cases, if your gross freelance income stays under \u00A31,000, you do not need to register or file Self Assessment. If your gross income goes over \u00A31,000, you must register and file, even if your expenses reduce your tax to \u00A30.',
      },
      {
        question: "Do I need to file Self Assessment if I'm employed and have a side income?",
        answer:
          "If you are employed and also earn freelance or side income, you may need to file Self Assessment if your gross trading income exceeds \u00A31,000 in a tax year.",
      },
      {
        question: 'Can I claim expenses and use the \u00A31,000 trading allowance together?',
        answer:
          'No. You must choose either the \u00A31,000 trading allowance or actual expenses when calculating profit \u2014 not both.',
      },
      {
        question: 'When is the Self Assessment deadline?',
        answer:
          'For most people, the online Self Assessment deadline is usually 31 January following the end of the tax year. Check the current HMRC deadlines for your situation.',
      },
    ],
  },
  {
    id: 'ct600',
    title: 'Corporation Tax (CT600)',
    items: [
      {
        question: 'What is CT600?',
        answer:
          'CT600 is the Corporation Tax return that UK limited companies file with HMRC to report profits and calculate Corporation Tax for an accounting period.',
      },
      {
        question: 'When is CT600 due?',
        answer:
          "CT600 is typically due within 12 months of the end of your company's accounting period. Corporation Tax payment is typically due earlier (often 9 months and 1 day after period end).",
      },
      {
        question: 'Do I still need to file CT600 if my company made a loss?',
        answer:
          'In many cases, yes. Limited companies usually still file a Corporation Tax return even if they made a loss. Losses can be carried forward or used under HMRC rules.',
      },
      {
        question: 'Can Neevii help with CT600?',
        answer:
          'Neevii supports tax-ready reporting and guided workflows for UK filings. CT600-related workflows may be available depending on your plan and rollout stage.',
      },
    ],
  },
  {
    id: 'vat',
    title: 'VAT',
    items: [
      {
        question: 'Do I need to register for VAT?',
        answer:
          'You may need to register if your taxable turnover exceeds the VAT registration threshold, or you can register voluntarily. Check the current HMRC threshold and rules for your situation.',
      },
      {
        question: 'What is Making Tax Digital (MTD) for VAT?',
        answer:
          'MTD for VAT is an HMRC requirement for many VAT-registered businesses to keep digital records and submit VAT information using compatible software.',
      },
      {
        question: 'Can Neevii help with VAT?',
        answer:
          'Neevii supports UK tax-ready reporting and workflows, including VAT-related tracking and preparation, depending on your plan and rollout stage.',
      },
    ],
  },
  {
    id: 'expenses',
    title: 'Expenses and bookkeeping',
    items: [
      {
        question: 'What business expenses can I claim?',
        answer:
          'Allowable expenses are costs that are wholly and exclusively for business. Common examples include software, equipment, travel for business, and professional services. Check HMRC guidance for specifics.',
      },
      {
        question: 'What records do I need to keep for HMRC?',
        answer:
          'HMRC generally requires records of income, expenses, invoices, and receipts. Neevii helps organise and store this information in a structured, HMRC-ready format.',
      },
      {
        question: 'Can I attach receipts to transactions?',
        answer:
          'Yes. Neevii supports attaching receipts so transactions are supported with evidence for bookkeeping and HMRC record keeping.',
      },
      {
        question: 'Is Neevii suitable for limited company directors?',
        answer:
          'Yes. Neevii supports limited company directors as well as sole traders, helping manage income, expenses, and tax-related records in one place.',
      },
    ],
  },
  {
    id: 'invoicing',
    title: 'Invoicing',
    items: [
      {
        question: 'Can I create and send invoices with Neevii?',
        answer:
          'Yes. Neevii supports creating and sending professional invoices and helps you keep invoice records alongside income and expenses.',
      },
      {
        question: 'Can I track whether invoices are paid?',
        answer:
          'Neevii helps you track invoice status and keep records linked to your bookkeeping workflow.',
      },
      {
        question: 'Can I send invoices from my phone?',
        answer:
          'Neevii is available on Android, and invoicing workflows are available depending on your plan and rollout stage.',
      },
    ],
  },
  {
    id: 'security-privacy',
    title: 'Security and privacy',
    items: [
      {
        question: 'Is my data encrypted?',
        answer:
          'Neevii uses encryption in transit (HTTPS/TLS), and your data is stored securely with standard security controls.',
      },
      {
        question: 'Do you sell my data?',
        answer: 'Neevii does not sell your financial data.',
      },
      {
        question: 'Can I request my data to be deleted?',
        answer: 'Yes. You can request deletion of your data via support.',
      },
    ],
  },
];

export const FAQS = FAQ_CLUSTERS.flatMap((c) => c.items);

export const FEATURED_FAQS = [
  'What is Neevii?',
  'Who is Neevii for?',
  'Can Neevii help with Self Assessment?',
  'Do I need to file Self Assessment if I earn under \u00A31,000?',
  'What records do I need to keep for HMRC?',
  'Is Neevii suitable for limited company directors?',
]
  .map((q) => FAQS.find((f) => f.question === q))
  .filter(Boolean);

function buildFaqSchemaItems(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };
}

export function getFaqPageSchema() {
  return buildFaqSchemaItems(FAQS);
}

export function getFaqPageSchemaForFaqs(items) {
  return buildFaqSchemaItems(items);
}

